module.exports = __webpack_public_path__ + "img/login-theme7.0f55d212.svg";